import { useMemo, useCallback } from 'react';
import { useOrderData } from './useOrderData';
import { useCheckoutData } from './useCheckoutData';
import { isLoading } from 'core/api/loadingHelpers';

export const useMyOrderPage = () => {
  const {
    loading: orderLoading,
    error: orderError,
    deliveryDays,
    getUserSwapsForDeliveryDay,
    handleDeleteSwapRequest: originalHandleDeleteSwapRequest,
    refetchOrders,
  } = useOrderData();

  const {
    loading: checkoutLoading,
    error: checkoutError,
    userSwapBillingSummary,
    refetchBillingSummary,
  } = useCheckoutData();

  const isPageLoading = useMemo(() => {
    return isLoading(orderLoading, getUserSwapsForDeliveryDay, orderError) ||
           isLoading(checkoutLoading, userSwapBillingSummary, checkoutError);
  }, [orderLoading, getUserSwapsForDeliveryDay, orderError, checkoutLoading, userSwapBillingSummary, checkoutError]);

  const finalAmount = useMemo(() => {
    return userSwapBillingSummary?.finalAmount || { amount: 0 };
  }, [userSwapBillingSummary]);

  // Enhanced delete handler that also refreshes billing summary
  const handleDeleteSwapRequest = useCallback(async (ids) => {
    try {
      await originalHandleDeleteSwapRequest(ids);
      // Refresh billing summary after successful deletion to update the PAY NOW amount
      await refetchBillingSummary();
    } catch (error) {
      console.error('Error in enhanced delete handler:', error);
      throw error;
    }
  }, [originalHandleDeleteSwapRequest, refetchBillingSummary]);

  return {
    // Loading states
    isLoading: isPageLoading,

    // Data
    deliveryDays,
    getUserSwapsForDeliveryDay,
    userSwapBillingSummary,
    finalAmount,

    // Actions
    handleDeleteSwapRequest,
    refetchOrders,
    refetchBillingSummary,
  };
};
